"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _component = _interopRequireDefault(require("../component.js"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*---------------------------------------------*/
var BasicInput = /*#__PURE__*/function (_Component) {
  _inherits(BasicInput, _Component);

  var _super = _createSuper(BasicInput);

  function BasicInput() {
    var _this;

    _classCallCheck(this, BasicInput);

    _this = _super.call(this);
    _this.state = {
      value: null
    };
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.onInputFocus = _this.onInputFocus.bind(_assertThisInitialized(_this));
    _this.onInputBlur = _this.onInputBlur.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(BasicInput, [{
    key: "onChange",
    value: function onChange(e) {
      var value = e.target.value;
      this.setState({
        value: value
      });
      this.props.onChange && this.props.onChange(value, this.props.name);
    }
  }, {
    key: "onInputFocus",
    value: function onInputFocus() {
      this.setState({
        inputHasFocus: true
      });
    }
  }, {
    key: "onInputBlur",
    value: function onInputBlur() {
      this.setState({
        inputHasFocus: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      this.resetClassNames();
      this.addClass(this.constructor.BASE_CLASS);
      this.addClass("".concat(this.constructor.BASE_CLASS, "--").concat(this.props.size || "normal"));
      this.state.inputHasFocus && this.addClass("lth-is-focus");

      var label = this.props.label && /*#__PURE__*/_react.default.createElement(_.Label, {
        disabled: this.props.disabled
      }, this.props.label);

      var message = this.props.message && /*#__PURE__*/_react.default.createElement("div", {
        className: this.constructor.BASE_CLASS + "__message"
      }, this.props.message);

      var iconLeft = this.props.iconLeft || /*#__PURE__*/_react.default.createElement("div", null);

      if (this.props.iconLeft && typeof this.props.iconLeft === "string") {
        iconLeft = /*#__PURE__*/_react.default.createElement(_.Icon, {
          icon: this.props.iconLeft,
          className: this.constructor.BASE_CLASS + "__icon",
          color: this.props.iconLeftColor,
          onClick: this.props.onIconLeftClick,
          size: 20
        });
      }

      var iconRight = this.props.iconRight || /*#__PURE__*/_react.default.createElement("div", null); // grid cell filler


      if (this.props.iconRight && typeof this.props.iconRight === "string") {
        iconRight = /*#__PURE__*/_react.default.createElement(_.Icon, {
          icon: this.props.iconRight,
          className: this.constructor.BASE_CLASS + "__icon",
          color: this.props.iconRightColor,
          onClick: this.props.onIconRightClick,
          size: 20
        });
      }

      var tooltip = this.props.tooltip ? /*#__PURE__*/_react.default.createElement(_.Tooltip, {
        className: this.constructor.BASE_CLASS + "__tooltip",
        content: this.props.tooltip
      }, /*#__PURE__*/_react.default.createElement(_.Icon, {
        icon: "help",
        size: 20
      })) : /*#__PURE__*/_react.default.createElement("div", null);
      var InputTag = this.props.type === "textarea" ? "textarea" : "input";
      var htmlProps = Object.fromEntries(HTML_INPUT_ATTRS.map(function (key) {
        return [key, _this2.props[key]];
      }).filter(function (pair) {
        return typeof pair[1] !== 'undefined';
      }));

      var inputProps = _objectSpread(_objectSpread({}, htmlProps), {}, {
        style: {
          width: this.props.inputWidth
        },
        type: this.props.type || "text",
        id: this.props.id,
        name: this.props.name,
        placeholder: this.props.placeholder !== undefined ? this.props.placeholder : "Enter your input",
        value: this.props.value !== undefined ? this.props.value : this.state.value || this.props.initialValue || "",
        inputMode: this.props.inputMode,
        pattern: this.props.pattern,
        min: this.props.min,
        max: this.props.max,
        rows: this.props.type === "textarea" ? this.props.rows : undefined,
        tabIndex: 0,
        onFocus: this.onInputFocus,
        onBlur: this.onInputBlur,
        onClick: this.props.onClick,
        onKeyDown: this.props.onKeyDown
      });

      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClassNames(),
        style: this.getStyle()
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: this.constructor.BASE_CLASS + "__label-container"
      }, label, tooltip), /*#__PURE__*/_react.default.createElement("label", {
        className: this.constructor.BASE_CLASS + "__container",
        style: {
          width: this.props.inputWidth ? "" : "100%"
        }
      }, iconLeft, /*#__PURE__*/_react.default.createElement(InputTag, _extends({}, inputProps, {
        className: this.constructor.BASE_CLASS + "__control",
        onChange: this.onChange,
        ref: this.ref
      })), iconRight), message);
    }
  }]);

  return BasicInput;
}(_component.default);
/*---------------------------------------------*/


_defineProperty(BasicInput, "BASE_CLASS", "lth-c-input");

var PasswordInput = /*#__PURE__*/function (_Component2) {
  _inherits(PasswordInput, _Component2);

  var _super2 = _createSuper(PasswordInput);

  function PasswordInput() {
    var _this3;

    _classCallCheck(this, PasswordInput);

    _this3 = _super2.call(this);
    _this3.state = {
      showPassword: false
    };
    return _this3;
  }

  _createClass(PasswordInput, [{
    key: "render",
    value: function render() {
      var _this4 = this;

      var inputProps = _objectSpread(_objectSpread({}, this.props), {}, {
        iconRight: this.state.showPassword ? "ViewOffFilled" : "view",
        type: this.state.showPassword ? "text" : "password",
        onIconRightClick: function onIconRightClick() {
          return _this4.setState({
            showPassword: !_this4.state.showPassword
          });
        }
      });

      return /*#__PURE__*/_react.default.createElement(BasicInput, inputProps);
    }
  }]);

  return PasswordInput;
}(_component.default);
/*---------------------------------------------*/


var NumberInput = /*#__PURE__*/function (_Component3) {
  _inherits(NumberInput, _Component3);

  var _super3 = _createSuper(NumberInput);

  function NumberInput() {
    _classCallCheck(this, NumberInput);

    return _super3.apply(this, arguments);
  }

  _createClass(NumberInput, [{
    key: "render",
    value: // change <type=number> to <type=text pattern='..'>?
    // https://technology.blog.gov.uk/2020/02/24/why-the-gov-uk-design-system-team-changed-the-input-type-for-numbers/
    function render() {
      var _this5 = this;

      var units = this.props.units;

      var inputProps = _objectSpread(_objectSpread({}, this.props), {}, {
        value: typeof this.props.value === "string" && units ? this.props.value.replace(units, "") : this.props.value,
        onChange: function onChange(value, name) {
          return _this5.props.onChange && _this5.props.onChange(units === undefined ? value : value + units, name);
        }
      });

      return /*#__PURE__*/_react.default.createElement(BasicInput, inputProps);
    }
  }]);

  return NumberInput;
}(_component.default);
/*---------------------------------------------*/


var Input = /*#__PURE__*/function (_Component4) {
  _inherits(Input, _Component4);

  var _super4 = _createSuper(Input);

  function Input() {
    _classCallCheck(this, Input);

    return _super4.apply(this, arguments);
  }

  _createClass(Input, [{
    key: "getValue",
    value: function getValue() {
      return this.ref.current.value;
    }
  }, {
    key: "render",
    value: function render() {
      switch (this.props.type) {
        case "password":
          {
            return /*#__PURE__*/_react.default.createElement(PasswordInput, this.props);
          }

        case "number":
          {
            return /*#__PURE__*/_react.default.createElement(NumberInput, this.props);
          }

        default:
          return /*#__PURE__*/_react.default.createElement(BasicInput, this.props);
      }
    }
  }]);

  return Input;
}(_component.default);
/*---------------------------------------------*/
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input


exports.default = Input;

_defineProperty(Input, "BASE_CLASS", "lth-c-input");

var HTML_INPUT_ATTRS = ['accept', 'alt', 'autocomplete', 'autofocus', 'capture', 'checked', 'dirname', 'disabled', 'form', 'formaction', 'formenctype', 'formmethod', 'formnovalidate', 'formtarget', 'height', 'list', 'max', 'maxlength', 'min', 'minlength', 'multiple', 'name', 'pattern', 'placeholder', 'readonly', 'required', 'size', 'src', 'step', 'width'];
/*---------------------------------------------*/

Input.METADATA = {
  name: "Input",
  props: [{
    name: "label",
    type: "string",
    default: "Enter your input"
  }, {
    name: "value",
    type: "string",
    default: undefined
  }, {
    name: "initialValue",
    type: "string",
    default: undefined
  }, {
    name: "type",
    type: "string",
    options: [{
      value: "text"
    }, {
      value: "password"
    }, {
      value: "number"
    }, {
      value: "textarea"
    }]
  }, {
    name: "size",
    type: "string",
    default: "normal",
    description: "Choose the size",
    options: [{
      value: "slim"
    }, {
      value: "normal"
    }]
  }, {
    name: "placeholder",
    type: "string",
    default: "Enter your input"
  }, {
    name: "units",
    type: "string",
    description: "Units, will be added to the value"
  }, {
    name: "tooltip",
    type: "string"
  }, {
    name: "disabled",
    type: "boolean",
    default: false
  }, {
    name: "error",
    type: "boolean",
    default: false
  }, {
    name: "forcehover",
    type: "boolean",
    default: false
  }, {
    name: "forcefocus",
    type: "boolean",
    default: false
  }, {
    name: "message",
    type: "string"
  }, {
    name: "iconLeft",
    type: "string"
  }, {
    name: "iconRight",
    type: "string"
  }, {
    name: "rows",
    type: "number",
    category: "style"
  }, {
    name: "inputWidth",
    type: "string",
    category: "style"
  }, {
    name: "onChange",
    type: "function"
  }]
};